import { render } from "./TarotGuideComponent.vue?vue&type=template&id=5b73375a&scoped=true"
import script from "./TarotGuideComponent.vue?vue&type=script&lang=js"
export * from "./TarotGuideComponent.vue?vue&type=script&lang=js"

import "./TarotGuideComponent.vue?vue&type=style&index=0&id=5b73375a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b73375a"]])

export default __exports__